let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gKk36")).then(() => parcelRequire('4vwvk'));